import * as React from "react";
import { useMappedState } from "redux-react-hook";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import { Button } from "src/library/components/Button";
import { Link } from "src/library/components/Link";
import { Text } from "src/library/components/Text";
import { Logo } from "src/core/shared/components/Logo";
import type { IStore } from "src/core/shared/store";
import { PageProps } from "src/pages/Router/routes";

/**
 * 403 No Access / Forbidden View
 *
 * @param {*} { history }
 * @returns
 */
const NoAccess: React.ReactFCWithChildren<PageProps<unknown>> = () => {
  const { user, role } = useMappedState((store: IStore) => ({
    user: store.global.user,
    role: store.global.role
  }));

  return (
    <BrandSplitView>
      <NoAccessInner>
        <Grid.Box className="logo-wrapper">
          <Logo type="dark" />
        </Grid.Box>

        <PaddedContainer>
          <Text
            weight="bold"
            letterSpacing="big"
            fontSize="h1"
          >
            403
          </Text>
        </PaddedContainer>

        <Grid.Box>
          <Text
            color="secondary"
            fontSize="p"
          >
            You don't have permission to access this page
          </Text>
        </Grid.Box>

        <PaddedContainer>
          {user ? (
            <Button>
              <Link
                color="white"
                to={role && role.type === "admin" ? role.code === "van-sales-admin" ? "/van-sales" : "/admin/dashboard" : "/dashboard"}
              >
                Dashboard
              </Link>
            </Button>
          ) : (
            <Button>
              <Link
                color="white"
                to="/"
              >
                Go to login
              </Link>
            </Button>
          )}
        </PaddedContainer>
      </NoAccessInner>
    </BrandSplitView>
  );
};

const PaddedContainer = styled(Grid.Box)`
  ${({ theme }) =>
    css`
      padding-top: ${theme.spacing.padding.xl};
    `};
`;

const NoAccessInner = styled(Grid.Bounds)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    css`
      padding: ${theme.spacing.padding.xl};
      padding-bottom: 0;
  `};

  .logo-wrapper {
    max-width: 400px;
  }
`;

export default NoAccess;
